import axios, { AxiosInstance } from 'axios';

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $axios: AxiosInstance;
  }
}

export const useBookingService = () => {
  const searchApiURL = process.env.SEARCH_MS_URL;
  const api = axios.create({
    baseURL: searchApiURL
  });
  return api;
};
